if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.boundOnSubmitHandler = this.onSubmitHandler.bind(this);
        this.initializeProductForm();
      }

      connectedCallback() {
        this.initializeProductForm();
      }

      initializeProductForm() {
        if (this.productFormInitialized) return;

        this.form = this.querySelector('form');
        const variantIdInput = this.variantIdInput;
        if (!this.form || !variantIdInput) return;

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;

        variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.boundOnSubmitHandler);
        this.submitButtonText = this.submitButton.querySelector('span');
        this.submitButtonLabel = this.submitButton.querySelector('.product-form__submit-label');
        this.submitButtonIcon = this.submitButton.querySelector('.product-form__submit-icon');
        this.defaultSubmitLabel =
          this.submitButton?.dataset.defaultLabel ||
          this.submitButtonLabel?.textContent?.trim() ||
          window.variantStrings.addToCart;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.productFormInitialized = true;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const isFigmaProductForm = Boolean(this.closest('product-info.product-layout-figma'));

        if (disable) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (text || !isFigmaProductForm) {
            this.submitButton.setAttribute('disabled', 'disabled');
          } else {
            this.submitButton.removeAttribute('disabled');
          }
          if (text) {
            this.setSubmitButtonText(text);
            this.toggleSubmitIcon(false);
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          this.setSubmitButtonText(this.defaultSubmitLabel);
          this.toggleSubmitIcon(true);
        }
      }

      setSubmitButtonText(text) {
        if (this.submitButtonLabel) {
          this.submitButtonLabel.textContent = text;
          return;
        }
        if (this.submitButtonText) {
          this.submitButtonText.textContent = text;
        }
      }

      toggleSubmitIcon(isVisible) {
        if (!this.submitButtonIcon) return;
        this.submitButtonIcon.classList.toggle('hidden', !isVisible);
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
